import { useWindowSize } from '~/composables/useWindowSize';
import { DESKTOP_WIDTH, MOBILE_WIDTH } from '~/constants';
export default (function () {
  var _useWindowSize = useWindowSize(),
    width = _useWindowSize.width,
    height = _useWindowSize.height;
  var isMobile = computed(function () {
    return width.value < DESKTOP_WIDTH;
  });
  var isTablet = computed(function () {
    return width.value >= MOBILE_WIDTH && width.value < DESKTOP_WIDTH;
  });
  var isPortrait = computed(function () {
    return width.value < height.value;
  });
  return {
    isMobile: isMobile,
    isTablet: isTablet,
    isPortrait: isPortrait
  };
});